// Per-seat last-run persistence for the Backtest Studio.
//
// A backtest result currently lives only in the active mode component's
// local state — navigate away and it's gone, even though the backend
// persisted the run server-side. This helper keeps the LAST completed run
// per MODE (result + the config that produced it) in localStorage so the
// user can leave the Backtest page and come back to their result.
//
// Shape: { config, results: { rules: {...}, signals: {...}, ml: {train,sweep}, ... } }
// Keyed per signed-in user (uid) when available, so one browser's seats
// don't clobber each other. Values are plain JSON (no secrets — results
// contain metrics/equity/trades only).

const PREFIX = 'aqap.lastRun.';

function keyFor(uid) {
  return PREFIX + (uid || 'anonymous');
}

export function loadLastRun(uid) {
  try {
    const raw = localStorage.getItem(keyFor(uid));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveLastRun(uid, payload) {
  try {
    localStorage.setItem(keyFor(uid), JSON.stringify(payload));
  } catch {
    /* storage unavailable — ignore; result just won't survive navigation */
  }
}

export function clearLastRun(uid) {
  try {
    localStorage.removeItem(keyFor(uid));
  } catch {
    /* ignore */
  }
}
